import { isMobile } from "react-device-detect";

export const getFcmCommunication = () => {
  if (isMobile) {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          type: "ACCESS_TOKEN",
          data: {
            accessToken: accessToken,
          },
        }),
      );
    }
  } else {
    return "not available";
  }
};

export const isAndroidApp = () =>
  typeof window !== 'undefined' && 
  typeof window.TOPTOP_APP?.getFCMToken === 'function';
 
export const isIOSApp = () =>
  typeof window !== 'undefined' &&
  typeof window.webkit?.messageHandlers?.getFCMToken === 'object';

export const isMobileWeb = () => {
  return !isAndroidApp() && !isIOSApp() && isMobile;
};

export const detectPlatform = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return "aw";
  if (/iPhone|iPad|iPod/.test(ua)) return "iw";
  return "w";
}